import Hero from '../components/home/Hero';
import Categories from '../components/home/Categories';
import WhyDarija from '../components/home/WhyDarija';
import Features from '../components/home/Features';
import HowItWorks from '../components/home/HowItWorks';
import CTA from '../components/home/CTA';

const Home = () => {
  return (
    <>
      <Hero />
      <Categories />
      <WhyDarija />
      <Features />
      <HowItWorks />
      <CTA />
    </>
  );
};

export default Home;
